module.exports = __webpack_public_path__ + "img/RTI_CES.df74f813.svg";